const putElementFromCard = (btnSelector) => {
    const putBTNs = document.querySelectorAll(btnSelector);
    putBTNs && putBTNs.forEach(btn => {
        btn.addEventListener('click', function (event) {
            event.preventDefault();
            event.stopPropagation();
            const putLink = btn.dataset.putlink;
            putLink && (document.location = putLink);
        });
    });
};
export default putElementFromCard;
